import { usePatchAgency } from '../data/usePatchAgency';

export function useChangeAgency(applicationId: string) {
  const { patchAgency, isPatchingAgency } = usePatchAgency(applicationId);

  async function changeAgency(newAgencyId: string) {
    return await patchAgency({
      newAgencyId: newAgencyId,
    });
  }

  return {
    changeAgency,
    isPatchingAgency,
  };
}
